import { Typography, useMediaQuery, useTheme } from '@mui/material';
import dayjs from 'dayjs';
import { useFormikContext } from 'formik';
import CustomDatePicker from '../../CustomDatePicker/CustomDatePicker';

export const FormikDatePicker = ({
  name,
  label,
  required,
}: {
  name: string;
  label: string;
  required: boolean;
}) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xl'));
  const { values, setFieldValue } = useFormikContext<any>();

  const raw = values[name];
  const dateValue = raw ? dayjs(raw) : null;

  return (
    <CustomDatePicker
      size={isXs ? 'small' : 'medium'}
      required={required}
      label={<Typography variant='responsiveBody2'>{label}</Typography>}
      value={dateValue}
      setValue={(newValue) => {
        const actualValue = typeof newValue === 'function' ? newValue(dateValue) : newValue;
        setFieldValue(name, actualValue ? actualValue.toDate() : null);
      }}
    />
  );
};
